<template>
  <template v-if="editableCustomerContact.id !== contact.id">
    <div class="block hover:bg-gray-100 dark:hover:bg-gray-770 rounded-lg">
      <div class="py-4">
        <div class="sm:flex flex-wrap lg:flex-nowrap px-2 items-center">

          <router-link :to="`/contacts/${contact.id}`" class="grid grid-cols-12 flex-1">
            <div class="col-span-12 sm:col-span-6 lg:col-span-3">
              <ItemText :text="contact.name" />
            </div>
            <div class="col-span-12 sm:col-span-6 lg:col-span-3 xl:col-span-2">
              <ItemText :text="contact.phone" />
            </div>
            <div class="col-span-12 sm:col-span-6 lg:col-span-3">
              <ItemText :text="contact.email" />
            </div>
          </router-link>

          <div class="ml-auto">
            <p class="mt-2 flex items-center text-sm text-gray-900 dark:text-gray-300 sm:mt-0">

              <!--  Edit button-->
              <template v-if="this.$userCan('manage_customers')">
                <Button icon="pencil" @click="editContact" />
              </template>

              <!--  Delete button-->
              <template v-if="this.$userCan('manage_customers')">
                <Button icon="delete" @click="deleteCustomerContact(contact.id)" />
              </template>
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>

  <template v-else>
    <EditCustomerContact :contact="contact" />
  </template>

</template>

<script>
import {mapGetters} from "vuex";
import ItemText from "@/components/Components/ItemText"
import EditCustomerContact from "@/components/Customer/CustomerContacts/EditCustomerContact"

export default {
  name: "ShowCustomerContact",
  components: {
    ItemText,
    EditCustomerContact,
  },
  props: ['contact'],
  computed: {
    ...mapGetters({
      customer: 'customer',
      editableCustomerContact: 'editableCustomerContact'
    })
  },
  methods: {
    inviteUserToContact(){
      this.$Progress.start()
      this.$store.dispatch('inviteUserToContact', {
        contactId: this.contact.id,
        customerId: this.customer.id
      })
    },
    revokeUserFromContact(){
      this.$Progress.start()
      this.$store.dispatch('revokeUserFromContact', {
        contactId: this.contact.id,
        customerId: this.customer.id
      })
    },
    editContact(){
      this.$store.dispatch('setEditableCustomerContact', this.contact)
    },
    deleteCustomerContact(contactId){
      if(confirm('Vai esi drošs?')){
        this.$Progress.start()
        this.$store.dispatch('deleteCustomerContact', {
            contactId: contactId,
            customerId: this.customer.id
        })
      }
    }
  }
}
</script>

<style>
</style>